import { Quiz, QuizDTO, QuizSubmission } from "../types/Quiz";
import client from "./axios";

const baseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/quizzes";
//const baseUrl = "http://localhost:3000/api/v1/admin/quizzes";

export const Quizzes = {
  getQuizzes: () => client.get<{ list: Quiz[] }>(`${baseUrl}`),
  getQuiz: (id: string) => client.get<{ quiz: Quiz }>(`${baseUrl}/${id}`),
  createQuiz: (body: QuizDTO) => client.post<{ quiz: Quiz }>(`${baseUrl}`, body),
  updateQuiz: (id: string, body: QuizDTO) =>
    client.put<{ quiz: Quiz }>(`${baseUrl}/${id}`, body),
  deleteQuiz: (id: string) =>
    client.delete<{ result: string }>(`${baseUrl}/${id}`),
  // Annulla la partecipazione di un utente stornandogli i punti: potrà rifarlo.
  revokeSubmission: (id: string, userId: string) =>
    client.delete<{ pointsEarned: number; revoked: number; giftPoints: number }>(
      `${baseUrl}/${id}/submissions/${userId}`
    ),
  getSubmissions: (id: string) =>
    client.get<{ list: QuizSubmission[] }>(`${baseUrl}/${id}/submissions`),
};
